var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowLeftSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.95654 3.70972C6.96302 3.71619 6.96627 3.72467 6.96631 3.73315L6.95654 3.75659L3.60107 7.11304L2.74756 7.96655H13.3335C13.3517 7.96666 13.3666 7.98153 13.3667 7.99976C13.3667 8.01807 13.3518 8.03285 13.3335 8.03296H2.74756L3.60107 8.88647L6.95654 12.2429C6.96301 12.2494 6.96624 12.2579 6.96631 12.2664L6.95654 12.2898C6.94998 12.2964 6.94173 12.2996 6.93311 12.2996L6.90967 12.2898L2.64307 8.02319C2.63661 8.01666 2.63325 8.00828 2.6333 7.99976L2.64307 7.97632L6.90967 3.70972C6.91612 3.70326 6.92465 3.7 6.93311 3.69995L6.95654 3.70972Z",
    fill: "#09090B",
    stroke: "#09090B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftSmall);
export default __webpack_public_path__ + "static/media/arrow-left-small.2dcd0e2e3d27d8a49eafa8d0318c1563.svg";
export { ForwardRef as ReactComponent };